import { thi_date } from "../../services/Helper";
import QRCode from "qrcode";
import { useState, useEffect } from "react";

const TestHeader = ({ header, print, pid, printRef }) => {
  const [QRCodeData, setQRCode] = useState([]);
  const { patientInfo, testInfo } = header;
  const pidClean = patientInfo?.pid?.replace(/^0+/, "");
  const margin = print ? "0 10px" : "0 30px";

  useEffect(() => {
    const qrinfo = `https://fohrabwah.org/report/all/print/${pidClean}/${testInfo?.testId?.replace(/^0+/, "")}`;
    QRCode.toDataURL(qrinfo).then(setQRCode).catch(console.error);
  }, [pidClean, testInfo]);

  const getRelation = () => {
    if (patientInfo?.husbandName) return `W/O ${patientInfo.husbandName}`;
    if (patientInfo?.fatherName) {
      const rel = patientInfo.gender === "M" ? "S/O" : "D/O";
      return `${rel} ${patientInfo.fatherName}`;
    }
    return "";
  };

  const formatDateTime = (dt) => {
    if (!dt) return "N/A";
    const d = new Date(dt);
    return `${thi_date(dt)} ${d.getHours().toString().padStart(2, "0")}:${d.getMinutes().toString().padStart(2, "0")}`;
  };

  return (
    <div className="print-header" style={{ margin }}>
      {/* Header 1: Hospital Info */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          borderBottom: "2px solid #0d6efd",
          paddingBottom: "10px",
          marginBottom: "10px",
          flexWrap: "wrap",
          gap: "10px",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <img src="/logo.jpeg" alt="FOH" width={print ? 60 : 80} />
          <div>
            <h5
              className="fw-bold mb-0"
              style={{ color: "#0d6efd", fontSize: print ? "12px" : undefined }}
            >
              Fazle Omar Pathology Lab
            </h5>
            <small style={{ color: "#6c757d" }}>Aqsa Road, Chenab Nagar</small>
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
          <div
            style={{
              fontSize: "12px",
              color: "#6c757d",
              textAlign: "right",
              lineHeight: "1.6",
            }}
          >
            <div>047-6215646 / 6213970</div>
            <div>info@fohrabwah.org</div>
            <div>www.fohrabwah.org</div>
          </div>
          <img src={QRCodeData} alt="QR" width={print ? 55 : 70} />
        </div>
      </div>

      {/* Header 2: Patient & Test Info */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          fontSize: "12px",
          marginBottom: "10px",
          paddingBottom: "10px",
          flexWrap: "wrap",
          gap: "10px",
        }}
      >
        <div style={{ lineHeight: "1.8" }}>
          <div style={{ fontSize: "13px" }}>
            <strong>
              {patientInfo?.name} {getRelation()}
            </strong>
          </div>
          <div>DOB: {patientInfo?.dob ? thi_date(patientInfo.dob) : "N/A"}</div>
          <div>Gender: {patientInfo?.gender === "M" ? "Male" : "Female"}</div>
          <div>Ref by: {testInfo?.physicianName || "N/A"}</div>
        </div>
        <div style={{ lineHeight: "1.8" }}>
          <div>
            <strong>Test ID: {testInfo?.testId}</strong>
          </div>
          <div>
            <strong>PID: {pidClean}</strong>
          </div>
          <div>Ward: {testInfo?.wardName || "N/A"}</div>
          <div style={{ display: "flex", gap: "5px", marginTop: "5px" }}>
            {["P", "K", "F"].map((l) => (
              <div
                key={l}
                style={{
                  width: "25px",
                  height: "25px",
                  border: "1px solid #000",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "12px",
                }}
              >
                {l}
              </div>
            ))}
          </div>
        </div>
        <div style={{ lineHeight: "1.8" }}>
          <div>
            Date of Test:{" "}
            {testInfo?.dateOfTest ? thi_date(testInfo.dateOfTest) : "N/A"}
          </div>
          <div>Time of Test: {testInfo?.timeOfTest || "N/A"}</div>
          <div>
            Sample:{" "}
            {formatDateTime(
              header.categories?.[0]?.tests?.[0]?.sampleCollectionDate,
            )}
          </div>
          <div>
            Result:{" "}
            {formatDateTime(
              header.categories?.[0]?.tests?.[0]?.resultRecordingDate,
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestHeader;
